import React, {
  createContext,
  ReactNode,
  useContext,
  useMemo,
  useState,
} from "react";

/**
 * Layout types for SAM
 * - drawer: SAM appears as a fixed drawer on the right side (audits page)
 * - bottom-bar: SAM slides up from bottom with a collapsed bar (all other pages)
 */
export type SAMLayout = "drawer" | "bottom-bar";

interface SAMLayoutContextType {
  layout: SAMLayout;
  setLayout: (layout: SAMLayout) => void;
}

const SAMLayoutContext =
  createContext<SAMLayoutContextType | undefined>(undefined);

export const useSAMLayout = () => {
  const context = useContext(SAMLayoutContext);
  if (!context) {
    throw new Error("useSAMLayout must be used within a SAMLayoutProvider");
  }
  return context;
};

interface SAMLayoutProviderProps {
  children: ReactNode;
}

export const SAMLayoutProvider: React.FC<SAMLayoutProviderProps> = ({
  children,
}) => {
  const [layout, setLayout] = useState<SAMLayout>("bottom-bar");

  const value = useMemo(() => ({ layout, setLayout }), [layout]);

  return (
    <SAMLayoutContext.Provider value={value}>
      {children}
    </SAMLayoutContext.Provider>
  );
};
